<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="introduce_breadcrumb" />
    </div>

    <div class="container-fluid" style="padding: 0">
      <div class="justify-content-center">
        <div class="imageTile1">
          <div class="innerText">
            <div class="innerTitle">Premium</div>
            <!--            <div class="innerDesc">{{ $t('premium_desc') }}</div>-->
            <div v-html="cvtCrToBr($t('premium_desc'))" class="innerDesc"></div>
          </div>
        </div>
        <div class="imageTile2">
          <div class="innerText">
            <div class="innerTitle">Private in Nature</div>
            <!--            <div class="innerDesc">{{ $t('private_desc') }}</div>-->
            <div v-html="cvtCrToBr($t('private_desc'))" class="innerDesc"></div>
          </div>
        </div>
        <div class="imageTile3">
          <div class="innerText">
            <div class="innerTitle">PINX</div>
            <!--            <div class="innerDesc">{{ $t('pinx_desc') }}</div>-->
            <div v-html="cvtCrToBr($t('pinx_desc'))" class="innerDesc"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GeneralUtil from '@/util/GeneralUtil';

export default {
  name: 'IntroducePage',
  mixins: [GeneralUtil],
  data() {
    return {
      introduce_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.introduce_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
td {
  border-width: 2px;
  border-color: darkgoldenrod;
  word-break: keep-all;
}
.overview_table {
  border-top: 3px solid #b8b19e;
  border-bottom: 1px solid #b8b19e;
  border-left-style: hidden;
  border-right-style: hidden;
}

.imageTile1 {
  width: 100%;
  margin: 0;
  background-image: url('~@/assets/images/pleisure/introduce/introduce_image01.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  .innerText {
    display: block;
    position: relative;
    width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 50vh;
  }
}

.imageTile2 {
  width: 100%;
  margin: 0;
  background-image: url('~@/assets/images/pleisure/introduce/introduce_image02.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  .innerText {
    display: block;
    position: relative;
    width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 80vh;
  }
}
.imageTile3 {
  width: 100%;
  margin: 0;
  background-image: url('~@/assets/images/pleisure/introduce/introduce_image03.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  .innerText {
    display: block;
    position: relative;
    width: 1280px;
    text-align: right;
    margin-left: auto;
    margin-right: auto;
    padding-top: 70vh;
  }
}

.innerTitle {
  font-size: 2rem;
  font-family: 'Noto Serif medium', serif;
  font-weight: bold;
  color: white;
  letter-spacing: -0.08rem;
}
.innerDesc {
  margin-top: 1rem;
  font-size: 0.9rem;
  font-family: 'Noto Sans KR', sans-serif;
  color: white;
  letter-spacing: -0.05rem;
}

@media (min-width: 1280px) {
}
@media (max-width: 1280px) {
  .imageTile1 {
    .innerText {
      width: 100%;
      text-align: left;
      padding-top: 70vh;
      padding-left: 1rem;
    }
  }
  .imageTile2 {
    .innerText {
      width: 100%;
      text-align: left;
      padding-top: 70vh;
      padding-left: 1rem;
    }
  }
  .imageTile3 {
    .innerText {
      width: 100%;
      text-align: left;
      padding-top: 70vh;
      padding-left: 1rem;
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "P-Leisure 소개",
    "premium_desc": "핀크스 레저에서는 프리미엄 고객을 위한 \n 특별한 프로그램들을 만날 수 있습니다.",
    "private_desc": "오직 소중한 사람들과 함께 즐기는 단독 레저로 \n 천혜의 자연 경관 제주를 느껴보세요.",
    "pinx_desc": "프로그램별 특화되어 있는 구성을 통해 \n 핀크스만의 차별화 된 서비스를 경험하세요."
  },
  "en": {
    "breadcrumb": "P-Leisure Introduction",
    "premium_desc": "At Pinx Leisure, you can meet special programs for premium customers.",
    "private_desc": "Feel the natural scenery of Jeju as a solo leisure with precious people.",
    "pinx_desc": "Experience Pinx’s unique service with specialized configurations for each program."
  },
  "ja": {
    "breadcrumb": "P-Leisure 소개",
    "premium_desc": "핀크스 레저에서는 프리미엄 고객을 위한 \n 특별한 프로그램들을 만날 수 있습니다.",
    "private_desc": "오직 소중한 사람들과 함께 즐기는 단독 레저로 \n 천혜의 자연 경관 제주를 느껴보세요.",
    "pinx_desc": "프로그램별 특화되어 있는 구성을 통해 \n 핀크스만의 차별화 된 서비스를 경험하세요."
  }
}
</i18n>
